// removed by extract-text-webpack-plugin
module.exports = {"menu":"index_1TsybIx","cur_menu":"index_2DTZrr_ index_1TsybIx","menu_wrap_style":"index_1BVRB3l"};


//////////////////
// WEBPACK FOOTER
// ./src/component/nav/index.css
// module id = 902
// module chunks = 0